import { GeofenceProperties } from '@customer/store/apis/interactionsApi';
import {
  createContext,
  Dispatch,
  PropsWithChildren,
  ReactElement,
  SetStateAction,
  useState,
} from 'react';

export const GeofenceTooltipGetterContext = createContext<GeofenceProperties | undefined>(
  undefined,
);

export const GeofenceTooltipSetterContext = createContext<
  Dispatch<SetStateAction<GeofenceProperties | undefined>> | undefined
>(undefined);

export const GeofenceTooltipContextProvider = ({ children }: PropsWithChildren): ReactElement => {
  const [tooltipProperties, setTooltipProperties] = useState<GeofenceProperties | undefined>(
    undefined,
  );

  return (
    <GeofenceTooltipSetterContext.Provider value={setTooltipProperties}>
      <GeofenceTooltipGetterContext.Provider value={tooltipProperties}>
        {children}
      </GeofenceTooltipGetterContext.Provider>
    </GeofenceTooltipSetterContext.Provider>
  );
};
